import HttpClient from '../../../core/HttpClient';
import { ICost } from '@leedpulse-monorepo/interfaces';
import Failure from '../../../core/Failure';

type GetSubscriptionCostsOptions = {
  limit: number;
  onlyCredits: boolean;
  start?: number;
  end?: number;
};

export type SubscriptionCostsResult = {
  costs: ICost[];
  consumed: number;
  oldest: number | null;
};

async function getSubscriptionCosts(
  subscriptionId: string,
  options: GetSubscriptionCostsOptions
): Promise<SubscriptionCostsResult> {
  try {
    const params = [`limit=${options.limit}`, `onlyCredits=${options.onlyCredits}`];
    if (options.start !== undefined) params.push(`start=${options.start}`);
    if (options.end !== undefined) params.push(`end=${options.end}`);
    const response = await HttpClient.get(
      `/backoffice/subscriptions/${subscriptionId}/costs?${params.join('&')}`
    );
    return (response?.data ?? { costs: [], consumed: 0, oldest: null }) as SubscriptionCostsResult;
  } catch (e) {
    throw new GetSubscriptionCostsFailure((e as Error).message);
  }
}

export class GetSubscriptionCostsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getSubscriptionCosts;
